module.exports = __webpack_public_path__ + "img/2025-07-21a_10.d717ebd1.jpg";